var map = {
	"./abort.webp": [
		"./StellarMateShared/images/abort.webp",
		12952
	],
	"./abort_motion.webp": [
		"./StellarMateShared/images/abort_motion.webp",
		15495
	],
	"./about.webp": [
		"./StellarMateShared/images/about.webp",
		30839
	],
	"./achievement.webp": [
		"./StellarMateShared/images/achievement.webp"
	],
	"./add-plus.webp": [
		"./StellarMateShared/images/add-plus.webp",
		71136
	],
	"./add-plus@2x.webp": [
		"./StellarMateShared/images/add-plus@2x.webp",
		18166
	],
	"./add-plus@3x.webp": [
		"./StellarMateShared/images/add-plus@3x.webp",
		33323
	],
	"./align-on.webp": [
		"./StellarMateShared/images/align-on.webp",
		73087
	],
	"./align-on@2x.webp": [
		"./StellarMateShared/images/align-on@2x.webp",
		67927
	],
	"./align-on@3x.webp": [
		"./StellarMateShared/images/align-on@3x.webp",
		99698
	],
	"./align.webp": [
		"./StellarMateShared/images/align.webp",
		67007
	],
	"./align@2x.webp": [
		"./StellarMateShared/images/align@2x.webp",
		94487
	],
	"./align@3x.webp": [
		"./StellarMateShared/images/align@3x.webp",
		49330
	],
	"./auto_calibration.webp": [
		"./StellarMateShared/images/auto_calibration.webp",
		3386
	],
	"./auto_calibration@2x.webp": [
		"./StellarMateShared/images/auto_calibration@2x.webp",
		44072
	],
	"./auto_calibration@3x.webp": [
		"./StellarMateShared/images/auto_calibration@3x.webp",
		72229
	],
	"./autorenew.webp": [
		"./StellarMateShared/images/autorenew.webp",
		66670
	],
	"./autorenew@2x.webp": [
		"./StellarMateShared/images/autorenew@2x.webp",
		88868
	],
	"./autorenew@3x.webp": [
		"./StellarMateShared/images/autorenew@3x.webp",
		8977
	],
	"./background.webp": [
		"./StellarMateShared/images/background.webp",
		35394
	],
	"./badges/11.webp": [
		"./StellarMateShared/images/badges/11.webp",
		90717
	],
	"./badges/begins.webp": [
		"./StellarMateShared/images/badges/begins.webp",
		86893
	],
	"./badges/bullseye.webp": [
		"./StellarMateShared/images/badges/bullseye.webp",
		8928
	],
	"./badges/cloud_magnet.webp": [
		"./StellarMateShared/images/badges/cloud_magnet.webp",
		21587
	],
	"./badges/cosmic_makeup.webp": [
		"./StellarMateShared/images/badges/cosmic_makeup.webp",
		58793
	],
	"./badges/cosmic_marathon.webp": [
		"./StellarMateShared/images/badges/cosmic_marathon.webp",
		66616
	],
	"./badges/dark_side.webp": [
		"./StellarMateShared/images/badges/dark_side.webp",
		72339
	],
	"./badges/details.webp": [
		"./StellarMateShared/images/badges/details.webp",
		1743
	],
	"./badges/director_cut.webp": [
		"./StellarMateShared/images/badges/director_cut.webp",
		67948
	],
	"./badges/explorer.webp": [
		"./StellarMateShared/images/badges/explorer.webp",
		40920
	],
	"./badges/first_light.webp": [
		"./StellarMateShared/images/badges/first_light.webp",
		37040
	],
	"./badges/magic_fingers.webp": [
		"./StellarMateShared/images/badges/magic_fingers.webp",
		68887
	],
	"./badges/mosaic_weaver.webp": [
		"./StellarMateShared/images/badges/mosaic_weaver.webp",
		74052
	],
	"./badges/perfectionist.webp": [
		"./StellarMateShared/images/badges/perfectionist.webp",
		24046
	],
	"./badges/sky_legend.webp": [
		"./StellarMateShared/images/badges/sky_legend.webp",
		54408
	],
	"./badges/sky_master.webp": [
		"./StellarMateShared/images/badges/sky_master.webp",
		39231
	],
	"./badges/storage.webp": [
		"./StellarMateShared/images/badges/storage.webp",
		3132
	],
	"./badges/wave_splitter.webp": [
		"./StellarMateShared/images/badges/wave_splitter.webp",
		62444
	],
	"./camera.webp": [
		"./StellarMateShared/images/camera.webp",
		57841
	],
	"./cancel.webp": [
		"./StellarMateShared/images/cancel.webp",
		69772
	],
	"./cancel@2x.webp": [
		"./StellarMateShared/images/cancel@2x.webp",
		98746
	],
	"./cancel@3x.webp": [
		"./StellarMateShared/images/cancel@3x.webp",
		61247
	],
	"./capture-on.webp": [
		"./StellarMateShared/images/capture-on.webp",
		68626
	],
	"./capture-on@2x.webp": [
		"./StellarMateShared/images/capture-on@2x.webp",
		77632
	],
	"./capture-on@3x.webp": [
		"./StellarMateShared/images/capture-on@3x.webp",
		35453
	],
	"./capture.webp": [
		"./StellarMateShared/images/capture.webp",
		57868
	],
	"./capture@2x.webp": [
		"./StellarMateShared/images/capture@2x.webp",
		16090
	],
	"./capture@3x.webp": [
		"./StellarMateShared/images/capture@3x.webp",
		55295
	],
	"./capture_qc.webp": [
		"./StellarMateShared/images/capture_qc.webp",
		16173
	],
	"./capture_qc_on.webp": [
		"./StellarMateShared/images/capture_qc_on.webp",
		97595
	],
	"./direction-base.webp": [
		"./StellarMateShared/images/direction-base.webp",
		95487
	],
	"./dome.webp": [
		"./StellarMateShared/images/dome.webp",
		2801
	],
	"./dslr.webp": [
		"./StellarMateShared/images/dslr.webp",
		23621
	],
	"./dust-cap.webp": [
		"./StellarMateShared/images/dust-cap.webp",
		21999
	],
	"./edit-pencil.webp": [
		"./StellarMateShared/images/edit-pencil.webp",
		21068
	],
	"./edit-pencil@2x.webp": [
		"./StellarMateShared/images/edit-pencil@2x.webp",
		38106
	],
	"./edit-pencil@3x.webp": [
		"./StellarMateShared/images/edit-pencil@3x.webp",
		84255
	],
	"./edit.webp": [
		"./StellarMateShared/images/edit.webp",
		38678
	],
	"./edit@2x.webp": [
		"./StellarMateShared/images/edit@2x.webp",
		78444
	],
	"./edit@3x.webp": [
		"./StellarMateShared/images/edit@3x.webp",
		48025
	],
	"./ekoslive_pro.webp": [
		"./StellarMateShared/images/ekoslive_pro.webp",
		98938
	],
	"./ethernet.webp": [
		"./StellarMateShared/images/ethernet.webp",
		58821
	],
	"./ethernet@2x.webp": [
		"./StellarMateShared/images/ethernet@2x.webp",
		42221
	],
	"./ethernet@3x.webp": [
		"./StellarMateShared/images/ethernet@3x.webp",
		1328
	],
	"./exposure_stopwatch.webp": [
		"./StellarMateShared/images/exposure_stopwatch.webp",
		19003
	],
	"./exposure_stopwatch@2x.webp": [
		"./StellarMateShared/images/exposure_stopwatch@2x.webp",
		63531
	],
	"./exposure_stopwatch@3x.webp": [
		"./StellarMateShared/images/exposure_stopwatch@3x.webp",
		14198
	],
	"./factoryReset.webp": [
		"./StellarMateShared/images/factoryReset.webp",
		83647
	],
	"./factoryReset@2x.webp": [
		"./StellarMateShared/images/factoryReset@2x.webp",
		35767
	],
	"./factoryReset@3x.webp": [
		"./StellarMateShared/images/factoryReset@3x.webp",
		90610
	],
	"./file_settings.webp": [
		"./StellarMateShared/images/file_settings.webp",
		55360
	],
	"./file_settings@2x.webp": [
		"./StellarMateShared/images/file_settings@2x.webp",
		16406
	],
	"./file_settings@3x.webp": [
		"./StellarMateShared/images/file_settings@3x.webp",
		1035
	],
	"./filter-wheel.webp": [
		"./StellarMateShared/images/filter-wheel.webp",
		52946
	],
	"./filter_settings.webp": [
		"./StellarMateShared/images/filter_settings.webp",
		86824
	],
	"./filter_settings@2x.webp": [
		"./StellarMateShared/images/filter_settings@2x.webp",
		74558
	],
	"./filter_settings@3x.webp": [
		"./StellarMateShared/images/filter_settings@3x.webp",
		23219
	],
	"./flatfocuspos.webp": [
		"./StellarMateShared/images/flatfocuspos.webp",
		44111
	],
	"./flatfocuspos@2x.webp": [
		"./StellarMateShared/images/flatfocuspos@2x.webp",
		82823
	],
	"./flatfocuspos@3x.webp": [
		"./StellarMateShared/images/flatfocuspos@3x.webp",
		86434
	],
	"./focus-on.webp": [
		"./StellarMateShared/images/focus-on.webp",
		45536
	],
	"./focus-on@2x.webp": [
		"./StellarMateShared/images/focus-on@2x.webp",
		88182
	],
	"./focus-on@3x.webp": [
		"./StellarMateShared/images/focus-on@3x.webp",
		37611
	],
	"./focus.webp": [
		"./StellarMateShared/images/focus.webp",
		40302
	],
	"./focus@2x.webp": [
		"./StellarMateShared/images/focus@2x.webp",
		91364
	],
	"./focus@3x.webp": [
		"./StellarMateShared/images/focus@3x.webp",
		11473
	],
	"./focus_in.webp": [
		"./StellarMateShared/images/focus_in.webp",
		27876
	],
	"./focus_out.webp": [
		"./StellarMateShared/images/focus_out.webp",
		19125
	],
	"./focuser.webp": [
		"./StellarMateShared/images/focuser.webp",
		18961
	],
	"./guide-on.webp": [
		"./StellarMateShared/images/guide-on.webp",
		58052
	],
	"./guide-on@3x.webp": [
		"./StellarMateShared/images/guide-on@3x.webp",
		46903
	],
	"./guide.webp": [
		"./StellarMateShared/images/guide.webp",
		25090
	],
	"./guide@2x.webp": [
		"./StellarMateShared/images/guide@2x.webp",
		67984
	],
	"./guide@3x.webp": [
		"./StellarMateShared/images/guide@3x.webp",
		8877
	],
	"./guider.webp": [
		"./StellarMateShared/images/guider.webp",
		99740
	],
	"./hotspot.webp": [
		"./StellarMateShared/images/hotspot.webp",
		34821
	],
	"./hotspot@2x.webp": [
		"./StellarMateShared/images/hotspot@2x.webp",
		96493
	],
	"./hotspot@3x.webp": [
		"./StellarMateShared/images/hotspot@3x.webp",
		42800
	],
	"./ic_restore_24px.webp": [
		"./StellarMateShared/images/ic_restore_24px.webp",
		2450
	],
	"./ic_restore_24px@2x.webp": [
		"./StellarMateShared/images/ic_restore_24px@2x.webp",
		16832
	],
	"./ic_restore_24px@3x.webp": [
		"./StellarMateShared/images/ic_restore_24px@3x.webp",
		91005
	],
	"./ikarus.webp": [
		"./StellarMateShared/images/ikarus.webp",
		91361
	],
	"./imatepro.webp": [
		"./StellarMateShared/images/imatepro.webp",
		95259
	],
	"./indi-on.webp": [
		"./StellarMateShared/images/indi-on.webp",
		91760
	],
	"./indi-on@2x.webp": [
		"./StellarMateShared/images/indi-on@2x.webp",
		44870
	],
	"./indi-on@3x.webp": [
		"./StellarMateShared/images/indi-on@3x.webp",
		32859
	],
	"./indi.webp": [
		"./StellarMateShared/images/indi.webp",
		78942
	],
	"./indi@2x.webp": [
		"./StellarMateShared/images/indi@2x.webp",
		32564
	],
	"./indi@3x.webp": [
		"./StellarMateShared/images/indi@3x.webp",
		71585
	],
	"./iso.webp": [
		"./StellarMateShared/images/iso.webp",
		25543
	],
	"./light-box.webp": [
		"./StellarMateShared/images/light-box.webp",
		94694
	],
	"./limit_settings.webp": [
		"./StellarMateShared/images/limit_settings.webp",
		13859
	],
	"./limit_settings@2x.webp": [
		"./StellarMateShared/images/limit_settings@2x.webp",
		21651
	],
	"./limit_settings@3x.webp": [
		"./StellarMateShared/images/limit_settings@3x.webp",
		72990
	],
	"./live_stacking.webp": [
		"./StellarMateShared/images/live_stacking.webp",
		91753
	],
	"./live_stacking_on.webp": [
		"./StellarMateShared/images/live_stacking_on.webp",
		33303
	],
	"./lock_filter.webp": [
		"./StellarMateShared/images/lock_filter.webp",
		3244
	],
	"./lock_filter@2x.webp": [
		"./StellarMateShared/images/lock_filter@2x.webp",
		22874
	],
	"./lock_filter@3x.webp": [
		"./StellarMateShared/images/lock_filter@3x.webp",
		69023
	],
	"./messiers/m1.webp": [
		"./StellarMateShared/images/messiers/m1.webp",
		54890
	],
	"./messiers/m10.webp": [
		"./StellarMateShared/images/messiers/m10.webp",
		60054
	],
	"./messiers/m100.webp": [
		"./StellarMateShared/images/messiers/m100.webp",
		77562
	],
	"./messiers/m101.webp": [
		"./StellarMateShared/images/messiers/m101.webp",
		49061
	],
	"./messiers/m102.webp": [
		"./StellarMateShared/images/messiers/m102.webp",
		87960
	],
	"./messiers/m103.webp": [
		"./StellarMateShared/images/messiers/m103.webp",
		64411
	],
	"./messiers/m104.webp": [
		"./StellarMateShared/images/messiers/m104.webp",
		39254
	],
	"./messiers/m105.webp": [
		"./StellarMateShared/images/messiers/m105.webp",
		96529
	],
	"./messiers/m106.webp": [
		"./StellarMateShared/images/messiers/m106.webp",
		37268
	],
	"./messiers/m107.webp": [
		"./StellarMateShared/images/messiers/m107.webp",
		60279
	],
	"./messiers/m108.webp": [
		"./StellarMateShared/images/messiers/m108.webp",
		51986
	],
	"./messiers/m109.webp": [
		"./StellarMateShared/images/messiers/m109.webp",
		3325
	],
	"./messiers/m11.webp": [
		"./StellarMateShared/images/messiers/m11.webp",
		17329
	],
	"./messiers/m110.webp": [
		"./StellarMateShared/images/messiers/m110.webp",
		68015
	],
	"./messiers/m12.webp": [
		"./StellarMateShared/images/messiers/m12.webp",
		58068
	],
	"./messiers/m13.webp": [
		"./StellarMateShared/images/messiers/m13.webp",
		81079
	],
	"./messiers/m14.webp": [
		"./StellarMateShared/images/messiers/m14.webp",
		98362
	],
	"./messiers/m15.webp": [
		"./StellarMateShared/images/messiers/m15.webp",
		69861
	],
	"./messiers/m16.webp": [
		"./StellarMateShared/images/messiers/m16.webp",
		8760
	],
	"./messiers/m17.webp": [
		"./StellarMateShared/images/messiers/m17.webp",
		85211
	],
	"./messiers/m18.webp": [
		"./StellarMateShared/images/messiers/m18.webp",
		93518
	],
	"./messiers/m19.webp": [
		"./StellarMateShared/images/messiers/m19.webp",
		32617
	],
	"./messiers/m2.webp": [
		"./StellarMateShared/images/messiers/m2.webp",
		87531
	],
	"./messiers/m20.webp": [
		"./StellarMateShared/images/messiers/m20.webp",
		9389
	],
	"./messiers/m21.webp": [
		"./StellarMateShared/images/messiers/m21.webp",
		46370
	],
	"./messiers/m22.webp": [
		"./StellarMateShared/images/messiers/m22.webp",
		53795
	],
	"./messiers/m23.webp": [
		"./StellarMateShared/images/messiers/m23.webp",
		66304
	],
	"./messiers/m24.webp": [
		"./StellarMateShared/images/messiers/m24.webp",
		79097
	],
	"./messiers/m25.webp": [
		"./StellarMateShared/images/messiers/m25.webp",
		18206
	],
	"./messiers/m26.webp": [
		"./StellarMateShared/images/messiers/m26.webp",
		31711
	],
	"./messiers/m27.webp": [
		"./StellarMateShared/images/messiers/m27.webp",
		30172
	],
	"./messiers/m28.webp": [
		"./StellarMateShared/images/messiers/m28.webp",
		25077
	],
	"./messiers/m29.webp": [
		"./StellarMateShared/images/messiers/m29.webp",
		8074
	],
	"./messiers/m3.webp": [
		"./StellarMateShared/images/messiers/m3.webp",
		53288
	],
	"./messiers/m30.webp": [
		"./StellarMateShared/images/messiers/m30.webp",
		52144
	],
	"./messiers/m31.webp": [
		"./StellarMateShared/images/messiers/m31.webp",
		77907
	],
	"./messiers/m32.webp": [
		"./StellarMateShared/images/messiers/m32.webp",
		70258
	],
	"./messiers/m33.webp": [
		"./StellarMateShared/images/messiers/m33.webp",
		94973
	],
	"./messiers/m34.webp": [
		"./StellarMateShared/images/messiers/m34.webp",
		34380
	],
	"./messiers/m35.webp": [
		"./StellarMateShared/images/messiers/m35.webp",
		9263
	],
	"./messiers/m36.webp": [
		"./StellarMateShared/images/messiers/m36.webp",
		32622
	],
	"./messiers/m37.webp": [
		"./StellarMateShared/images/messiers/m37.webp",
		28649
	],
	"./messiers/m38.webp": [
		"./StellarMateShared/images/messiers/m38.webp",
		53208
	],
	"./messiers/m39.webp": [
		"./StellarMateShared/images/messiers/m39.webp",
		91579
	],
	"./messiers/m4.webp": [
		"./StellarMateShared/images/messiers/m4.webp",
		78561
	],
	"./messiers/m40.webp": [
		"./StellarMateShared/images/messiers/m40.webp",
		45631
	],
	"./messiers/m41.webp": [
		"./StellarMateShared/images/messiers/m41.webp",
		55388
	],
	"./messiers/m42.webp": [
		"./StellarMateShared/images/messiers/m42.webp",
		98425
	],
	"./messiers/m43.webp": [
		"./StellarMateShared/images/messiers/m43.webp",
		56990
	],
	"./messiers/m44.webp": [
		"./StellarMateShared/images/messiers/m44.webp",
		50051
	],
	"./messiers/m45.webp": [
		"./StellarMateShared/images/messiers/m45.webp",
		3296
	],
	"./messiers/m46.webp": [
		"./StellarMateShared/images/messiers/m46.webp",
		97965
	],
	"./messiers/m47.webp": [
		"./StellarMateShared/images/messiers/m47.webp",
		42402
	],
	"./messiers/m48.webp": [
		"./StellarMateShared/images/messiers/m48.webp",
		58951
	],
	"./messiers/m49.webp": [
		"./StellarMateShared/images/messiers/m49.webp",
		5252
	],
	"./messiers/m5.webp": [
		"./StellarMateShared/images/messiers/m5.webp",
		8806
	],
	"./messiers/m50.webp": [
		"./StellarMateShared/images/messiers/m50.webp",
		69098
	],
	"./messiers/m51.webp": [
		"./StellarMateShared/images/messiers/m51.webp",
		36629
	],
	"./messiers/m52.webp": [
		"./StellarMateShared/images/messiers/m52.webp",
		13576
	],
	"./messiers/m53.webp": [
		"./StellarMateShared/images/messiers/m53.webp",
		21515
	],
	"./messiers/m54.webp": [
		"./StellarMateShared/images/messiers/m54.webp",
		92390
	],
	"./messiers/m55.webp": [
		"./StellarMateShared/images/messiers/m55.webp",
		62145
	],
	"./messiers/m56.webp": [
		"./StellarMateShared/images/messiers/m56.webp",
		20548
	],
	"./messiers/m57.webp": [
		"./StellarMateShared/images/messiers/m57.webp",
		34727
	],
	"./messiers/m58.webp": [
		"./StellarMateShared/images/messiers/m58.webp",
		450
	],
	"./messiers/m59.webp": [
		"./StellarMateShared/images/messiers/m59.webp",
		56013
	],
	"./messiers/m6.webp": [
		"./StellarMateShared/images/messiers/m6.webp",
		24423
	],
	"./messiers/m60.webp": [
		"./StellarMateShared/images/messiers/m60.webp",
		90961
	],
	"./messiers/m61.webp": [
		"./StellarMateShared/images/messiers/m61.webp",
		55734
	],
	"./messiers/m62.webp": [
		"./StellarMateShared/images/messiers/m62.webp",
		97559
	],
	"./messiers/m63.webp": [
		"./StellarMateShared/images/messiers/m63.webp",
		96500
	],
	"./messiers/m64.webp": [
		"./StellarMateShared/images/messiers/m64.webp",
		73061
	],
	"./messiers/m65.webp": [
		"./StellarMateShared/images/messiers/m65.webp",
		42682
	],
	"./messiers/m66.webp": [
		"./StellarMateShared/images/messiers/m66.webp",
		3131
	],
	"./messiers/m67.webp": [
		"./StellarMateShared/images/messiers/m67.webp",
		17784
	],
	"./messiers/m68.webp": [
		"./StellarMateShared/images/messiers/m68.webp",
		32745
	],
	"./messiers/m69.webp": [
		"./StellarMateShared/images/messiers/m69.webp",
		63022
	],
	"./messiers/m7.webp": [
		"./StellarMateShared/images/messiers/m7.webp",
		60388
	],
	"./messiers/m70.webp": [
		"./StellarMateShared/images/messiers/m70.webp",
		59332
	],
	"./messiers/m71.webp": [
		"./StellarMateShared/images/messiers/m71.webp",
		21927
	],
	"./messiers/m72.webp": [
		"./StellarMateShared/images/messiers/m72.webp",
		15142
	],
	"./messiers/m73.webp": [
		"./StellarMateShared/images/messiers/m73.webp",
		6817
	],
	"./messiers/m74.webp": [
		"./StellarMateShared/images/messiers/m74.webp",
		44904
	],
	"./messiers/m75.webp": [
		"./StellarMateShared/images/messiers/m75.webp",
		42283
	],
	"./messiers/m76.webp": [
		"./StellarMateShared/images/messiers/m76.webp",
		40394
	],
	"./messiers/m77.webp": [
		"./StellarMateShared/images/messiers/m77.webp",
		44661
	],
	"./messiers/m78.webp": [
		"./StellarMateShared/images/messiers/m78.webp",
		48092
	],
	"./messiers/m79.webp": [
		"./StellarMateShared/images/messiers/m79.webp",
		76031
	],
	"./messiers/m8.webp": [
		"./StellarMateShared/images/messiers/m8.webp",
		56205
	],
	"./messiers/m80.webp": [
		"./StellarMateShared/images/messiers/m80.webp",
		68947
	],
	"./messiers/m81.webp": [
		"./StellarMateShared/images/messiers/m81.webp",
		43184
	],
	"./messiers/m82.webp": [
		"./StellarMateShared/images/messiers/m82.webp",
		86013
	],
	"./messiers/m83.webp": [
		"./StellarMateShared/images/messiers/m83.webp",
		34674
	],
	"./messiers/m84.webp": [
		"./StellarMateShared/images/messiers/m84.webp",
		14703
	],
	"./messiers/m85.webp": [
		"./StellarMateShared/images/messiers/m85.webp",
		73836
	],
	"./messiers/m86.webp": [
		"./StellarMateShared/images/messiers/m86.webp",
		94505
	],
	"./messiers/m87.webp": [
		"./StellarMateShared/images/messiers/m87.webp",
		55406
	],
	"./messiers/m88.webp": [
		"./StellarMateShared/images/messiers/m88.webp",
		47099
	],
	"./messiers/m89.webp": [
		"./StellarMateShared/images/messiers/m89.webp",
		70648
	],
	"./messiers/m9.webp": [
		"./StellarMateShared/images/messiers/m9.webp",
		9538
	],
	"./messiers/m90.webp": [
		"./StellarMateShared/images/messiers/m90.webp",
		80094
	],
	"./messiers/m91.webp": [
		"./StellarMateShared/images/messiers/m91.webp",
		40985
	],
	"./messiers/m92.webp": [
		"./StellarMateShared/images/messiers/m92.webp",
		92060
	],
	"./messiers/m93.webp": [
		"./StellarMateShared/images/messiers/m93.webp",
		93599
	],
	"./messiers/m94.webp": [
		"./StellarMateShared/images/messiers/m94.webp",
		8258
	],
	"./messiers/m95.webp": [
		"./StellarMateShared/images/messiers/m95.webp",
		71277
	],
	"./messiers/m96.webp": [
		"./StellarMateShared/images/messiers/m96.webp",
		28192
	],
	"./messiers/m97.webp": [
		"./StellarMateShared/images/messiers/m97.webp",
		15683
	],
	"./messiers/m98.webp": [
		"./StellarMateShared/images/messiers/m98.webp",
		7526
	],
	"./messiers/m99.webp": [
		"./StellarMateShared/images/messiers/m99.webp",
		93633
	],
	"./moon/moon00.webp": [
		"./StellarMateShared/images/moon/moon00.webp",
		49625
	],
	"./moon/moon01.webp": [
		"./StellarMateShared/images/moon/moon01.webp",
		38590
	],
	"./moon/moon02.webp": [
		"./StellarMateShared/images/moon/moon02.webp",
		48191
	],
	"./moon/moon03.webp": [
		"./StellarMateShared/images/moon/moon03.webp",
		69948
	],
	"./moon/moon04.webp": [
		"./StellarMateShared/images/moon/moon04.webp",
		22317
	],
	"./moon/moon05.webp": [
		"./StellarMateShared/images/moon/moon05.webp",
		66754
	],
	"./moon/moon06.webp": [
		"./StellarMateShared/images/moon/moon06.webp",
		31651
	],
	"./moon/moon07.webp": [
		"./StellarMateShared/images/moon/moon07.webp",
		48608
	],
	"./moon/moon08.webp": [
		"./StellarMateShared/images/moon/moon08.webp",
		28449
	],
	"./moon/moon09.webp": [
		"./StellarMateShared/images/moon/moon09.webp",
		58694
	],
	"./moon/moon10.webp": [
		"./StellarMateShared/images/moon/moon10.webp",
		31084
	],
	"./moon/moon11.webp": [
		"./StellarMateShared/images/moon/moon11.webp",
		99023
	],
	"./moon/moon12.webp": [
		"./StellarMateShared/images/moon/moon12.webp",
		29326
	],
	"./moon/moon13.webp": [
		"./StellarMateShared/images/moon/moon13.webp",
		99049
	],
	"./moon/moon14.webp": [
		"./StellarMateShared/images/moon/moon14.webp",
		84976
	],
	"./moon/moon15.webp": [
		"./StellarMateShared/images/moon/moon15.webp",
		79059
	],
	"./moon/moon16.webp": [
		"./StellarMateShared/images/moon/moon16.webp",
		33714
	],
	"./moon/moon17.webp": [
		"./StellarMateShared/images/moon/moon17.webp",
		93629
	],
	"./moon/moon18.webp": [
		"./StellarMateShared/images/moon/moon18.webp",
		79156
	],
	"./moon/moon19.webp": [
		"./StellarMateShared/images/moon/moon19.webp",
		63863
	],
	"./moon/moon20.webp": [
		"./StellarMateShared/images/moon/moon20.webp",
		90919
	],
	"./moon/moon21.webp": [
		"./StellarMateShared/images/moon/moon21.webp",
		37220
	],
	"./moon/moon22.webp": [
		"./StellarMateShared/images/moon/moon22.webp",
		57857
	],
	"./moon/moon23.webp": [
		"./StellarMateShared/images/moon/moon23.webp",
		43014
	],
	"./moon/moon24.webp": [
		"./StellarMateShared/images/moon/moon24.webp",
		779
	],
	"./moon/moon25.webp": [
		"./StellarMateShared/images/moon/moon25.webp",
		60872
	],
	"./moon/moon26.webp": [
		"./StellarMateShared/images/moon/moon26.webp",
		53301
	],
	"./moon/moon27.webp": [
		"./StellarMateShared/images/moon/moon27.webp",
		7786
	],
	"./moon/moon28.webp": [
		"./StellarMateShared/images/moon/moon28.webp",
		77599
	],
	"./moon/moon29.webp": [
		"./StellarMateShared/images/moon/moon29.webp",
		87356
	],
	"./moon/moon30.webp": [
		"./StellarMateShared/images/moon/moon30.webp",
		20018
	],
	"./moon/moon31.webp": [
		"./StellarMateShared/images/moon/moon31.webp",
		6429
	],
	"./moon/moon32.webp": [
		"./StellarMateShared/images/moon/moon32.webp",
		28528
	],
	"./moon/moon33.webp": [
		"./StellarMateShared/images/moon/moon33.webp",
		50739
	],
	"./moon/moon34.webp": [
		"./StellarMateShared/images/moon/moon34.webp",
		26350
	],
	"./moon/moon35.webp": [
		"./StellarMateShared/images/moon/moon35.webp",
		96073
	],
	"./mount-on.webp": [
		"./StellarMateShared/images/mount-on.webp",
		80127
	],
	"./mount-on@2x.webp": [
		"./StellarMateShared/images/mount-on@2x.webp",
		47031
	],
	"./mount-on@3x.webp": [
		"./StellarMateShared/images/mount-on@3x.webp",
		71346
	],
	"./mount-train.webp": [
		"./StellarMateShared/images/mount-train.webp",
		13796
	],
	"./mount@2x.webp": [
		"./StellarMateShared/images/mount@2x.webp",
		12375
	],
	"./mount@3x.webp": [
		"./StellarMateShared/images/mount@3x.webp",
		13170
	],
	"./mount_qc.webp": [
		"./StellarMateShared/images/mount_qc.webp",
		88520
	],
	"./mount_qc_on.webp": [
		"./StellarMateShared/images/mount_qc_on.webp",
		90464
	],
	"./objects/asteroids.webp": [
		"./StellarMateShared/images/objects/asteroids.webp",
		40271
	],
	"./objects/comets.webp": [
		"./StellarMateShared/images/objects/comets.webp",
		98030
	],
	"./objects/galaxies.webp": [
		"./StellarMateShared/images/objects/galaxies.webp",
		22415
	],
	"./objects/gaseousnebulae.webp": [
		"./StellarMateShared/images/objects/gaseousnebulae.webp",
		76742
	],
	"./objects/globularclusters.webp": [
		"./StellarMateShared/images/objects/globularclusters.webp",
		95992
	],
	"./objects/openclusters.webp": [
		"./StellarMateShared/images/objects/openclusters.webp",
		44136
	],
	"./objects/planetarynebulae.webp": [
		"./StellarMateShared/images/objects/planetarynebulae.webp",
		98829
	],
	"./objects/planets.webp": [
		"./StellarMateShared/images/objects/planets.webp",
		40618
	],
	"./objects/stars.webp": [
		"./StellarMateShared/images/objects/stars.webp",
		62536
	],
	"./objects/supernovae.webp": [
		"./StellarMateShared/images/objects/supernovae.webp",
		51763
	],
	"./observatory-on.webp": [
		"./StellarMateShared/images/observatory-on.webp",
		61436
	],
	"./observatory-on@2x.webp": [
		"./StellarMateShared/images/observatory-on@2x.webp",
		74058
	],
	"./observatory-on@3x.webp": [
		"./StellarMateShared/images/observatory-on@3x.webp",
		81103
	],
	"./observatory.webp": [
		"./StellarMateShared/images/observatory.webp",
		84858
	],
	"./observatory@2x.webp": [
		"./StellarMateShared/images/observatory@2x.webp",
		9064
	],
	"./observatory@3x.webp": [
		"./StellarMateShared/images/observatory@3x.webp",
		29893
	],
	"./openVNC.webp": [
		"./StellarMateShared/images/openVNC.webp",
		34379
	],
	"./openVNC@2x.webp": [
		"./StellarMateShared/images/openVNC@2x.webp",
		86267
	],
	"./openVNC@3x.webp": [
		"./StellarMateShared/images/openVNC@3x.webp",
		46694
	],
	"./plans.webp": [
		"./StellarMateShared/images/plans.webp",
		85206
	],
	"./reducer.webp": [
		"./StellarMateShared/images/reducer.webp",
		63638
	],
	"./resolution.webp": [
		"./StellarMateShared/images/resolution.webp",
		13476
	],
	"./resolution@2x.webp": [
		"./StellarMateShared/images/resolution@2x.webp",
		55282
	],
	"./resolution@3x.webp": [
		"./StellarMateShared/images/resolution@3x.webp",
		30967
	],
	"./restart.webp": [
		"./StellarMateShared/images/restart.webp",
		50413
	],
	"./restart@2x.webp": [
		"./StellarMateShared/images/restart@2x.webp",
		53493
	],
	"./restart@3x.webp": [
		"./StellarMateShared/images/restart@3x.webp",
		60824
	],
	"./rotator.webp": [
		"./StellarMateShared/images/rotator.webp",
		64127
	],
	"./rotator_qc.webp": [
		"./StellarMateShared/images/rotator_qc.webp",
		68008
	],
	"./rotator_qc_on.webp": [
		"./StellarMateShared/images/rotator_qc_on.webp",
		76928
	],
	"./save.webp": [
		"./StellarMateShared/images/save.webp",
		4947
	],
	"./save@2x.webp": [
		"./StellarMateShared/images/save@2x.webp",
		57923
	],
	"./save@3x.webp": [
		"./StellarMateShared/images/save@3x.webp",
		36750
	],
	"./scheduler-on.webp": [
		"./StellarMateShared/images/scheduler-on.webp",
		68611
	],
	"./scheduler-on@2x.webp": [
		"./StellarMateShared/images/scheduler-on@2x.webp",
		71155
	],
	"./scheduler-on@3x.webp": [
		"./StellarMateShared/images/scheduler-on@3x.webp",
		75358
	],
	"./scheduler.webp": [
		"./StellarMateShared/images/scheduler.webp",
		62867
	],
	"./scheduler@2x.webp": [
		"./StellarMateShared/images/scheduler@2x.webp",
		48163
	],
	"./scheduler@3x.webp": [
		"./StellarMateShared/images/scheduler@3x.webp",
		70958
	],
	"./scope.webp": [
		"./StellarMateShared/images/scope.webp",
		11438
	],
	"./setting.webp": [
		"./StellarMateShared/images/setting.webp",
		74902
	],
	"./setting@2x.webp": [
		"./StellarMateShared/images/setting@2x.webp",
		9356
	],
	"./setting@3x.webp": [
		"./StellarMateShared/images/setting@3x.webp",
		75929
	],
	"./shutdown.webp": [
		"./StellarMateShared/images/shutdown.webp",
		80920
	],
	"./shutdown@2x.webp": [
		"./StellarMateShared/images/shutdown@2x.webp",
		16910
	],
	"./shutdown@3x.webp": [
		"./StellarMateShared/images/shutdown@3x.webp",
		20419
	],
	"./skymap/kstars_cbound.webp": [
		"./StellarMateShared/images/skymap/kstars_cbound.webp",
		70164
	],
	"./skymap/kstars_cnames.webp": [
		"./StellarMateShared/images/skymap/kstars_cnames.webp",
		57132
	],
	"./skymap/kstars_deepsky.webp": [
		"./StellarMateShared/images/skymap/kstars_deepsky.webp",
		32870
	],
	"./skymap/kstars_dss.webp": [
		"./StellarMateShared/images/skymap/kstars_dss.webp",
		879
	],
	"./skymap/kstars_grid.webp": [
		"./StellarMateShared/images/skymap/kstars_grid.webp",
		90123
	],
	"./skymap/kstars_horizon.webp": [
		"./StellarMateShared/images/skymap/kstars_horizon.webp",
		43502
	],
	"./skymap/kstars_mw.webp": [
		"./StellarMateShared/images/skymap/kstars_mw.webp",
		47163
	],
	"./skymap/kstars_planets.webp": [
		"./StellarMateShared/images/skymap/kstars_planets.webp",
		98058
	],
	"./skymap/kstars_satellites.webp": [
		"./StellarMateShared/images/skymap/kstars_satellites.webp",
		53993
	],
	"./skymap/kstars_solarsystem.webp": [
		"./StellarMateShared/images/skymap/kstars_solarsystem.webp",
		54189
	],
	"./skymap/kstars_stars.webp": [
		"./StellarMateShared/images/skymap/kstars_stars.webp",
		6376
	],
	"./skymap/kstars_supernovae.webp": [
		"./StellarMateShared/images/skymap/kstars_supernovae.webp",
		24051
	],
	"./skymap/lock.webp": [
		"./StellarMateShared/images/skymap/lock.webp",
		35431
	],
	"./smpro.webp": [
		"./StellarMateShared/images/smpro.webp",
		7921
	],
	"./space.webp": [
		"./StellarMateShared/images/space.webp",
		84384
	],
	"./splash.webp": [
		"./StellarMateShared/images/splash.webp",
		97337
	],
	"./stellarmatex.webp": [
		"./StellarMateShared/images/stellarmatex.webp",
		91850
	],
	"./sun.webp": [
		"./StellarMateShared/images/sun.webp",
		10664
	],
	"./trash-empty.webp": [
		"./StellarMateShared/images/trash-empty.webp",
		48720
	],
	"./trash-empty@2x.webp": [
		"./StellarMateShared/images/trash-empty@2x.webp",
		55590
	],
	"./trash-empty@3x.webp": [
		"./StellarMateShared/images/trash-empty@3x.webp",
		95163
	],
	"./weather/brokenClouds.webp": [
		"./StellarMateShared/images/weather/brokenClouds.webp",
		5540
	],
	"./weather/clearSky.webp": [
		"./StellarMateShared/images/weather/clearSky.webp",
		12333
	],
	"./weather/fewClouds.webp": [
		"./StellarMateShared/images/weather/fewClouds.webp",
		75861
	],
	"./weather/mist.webp": [
		"./StellarMateShared/images/weather/mist.webp",
		43762
	],
	"./weather/rain.webp": [
		"./StellarMateShared/images/weather/rain.webp",
		78989
	],
	"./weather/scatteredClouds.webp": [
		"./StellarMateShared/images/weather/scatteredClouds.webp",
		71544
	],
	"./weather/showerRain.webp": [
		"./StellarMateShared/images/weather/showerRain.webp",
		31879
	],
	"./weather/snow.webp": [
		"./StellarMateShared/images/weather/snow.webp",
		9272
	],
	"./weather/thunderstorm.webp": [
		"./StellarMateShared/images/weather/thunderstorm.webp",
		89844
	],
	"./weather/wind.webp": [
		"./StellarMateShared/images/weather/wind.webp",
		90513
	],
	"./webManager.webp": [
		"./StellarMateShared/images/webManager.webp",
		77671
	],
	"./webManager@2x.webp": [
		"./StellarMateShared/images/webManager@2x.webp",
		4607
	],
	"./webManager@3x.webp": [
		"./StellarMateShared/images/webManager@3x.webp",
		58458
	],
	"./wifi.webp": [
		"./StellarMateShared/images/wifi.webp",
		12659
	],
	"./wifi@2x.webp": [
		"./StellarMateShared/images/wifi@2x.webp",
		42339
	],
	"./wifi@3x.webp": [
		"./StellarMateShared/images/wifi@3x.webp",
		38830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./StellarMateShared/images lazy recursive ^\\.\\/.*\\.webp$";
module.exports = webpackAsyncContext;